export default "__VITE_ASSET__Bu7GtTWQ__"